var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loadFlag)?_c('HomeComp'):_vm._e(),_c('p',[_vm._v("ICP证：浙B2-20220316 网站备案：浙ICP备19014071号-1 浙网文 【2016】5750-326号")]),_c('p',[_vm._v(" APP备案：浙ICP备18015926号-31A 浙公网安备33021202003585号")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }